import { render, staticRenderFns } from "./FPotensIKawasanBagunan.vue?vue&type=template&id=2a6b36d6&scoped=true"
import script from "./FPotensIKawasanBagunan.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanBagunan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b36d6",
  null
  
)

export default component.exports